import React, { Fragment, useEffect, useState } from "react";
import { Btn, LI, UL } from "../../../../AbstractElements";
import Delete from "../../../../assets/icons/delete.svg";
import { Col } from "reactstrap";
import {
  AmountCollected,
  InvoiceTotalNo,
  Invoicetotal,
  Prevdues,
  Sub_total,
  Subtotal,
  TotalDues,
  WalletMoney,
  form,
} from "../../../../Constant";

const InvoiceTotal = (props) => {
  const [currency, setcurrency] = useState("");
  const [historyAmount, sethistoryAmount] = useState(0);
  const invoiceValue = props.item;
  const discountAmount = props.discountAmount;
  const finalTotal = props.finalTotal;
  const removeCoupon = props.removeCoupon;
  return (
    <Fragment>
      <Col >
        <div className="checkout-details d-flex justify-content-end ">
          <div className="order-box ">
            <UL>
              <LI>
                {Subtotal} : <span>₹ {invoiceValue?.sub_total}</span>
              </LI>
              {discountAmount && (
                <LI>
                  Coupon Discount:{" "}
                  <span className="text-success" style={{display: "inline-flex",  alignItems: "center" ,gap: "6px"}}>- ₹ {discountAmount}
                  {discountAmount && (
                      <img
                        src={Delete}
                        style={{ cursor: "pointer", width:"15px"}}
                        onClick={() =>{removeCoupon()}}
                      />
                  )}
                  </span>
                </LI>
              )}

              {invoiceValue?.total_tax > 0 &&
                invoiceValue.orderTaxDetails.map(
                  (e) =>
                    e.total_amount != 0 && (
                      <LI key={e.id}>
                        {e.tax_name} {e.tax_percentage}% :{" "}
                        <span>₹ {e.total_amount}</span>
                      </LI>
                    ),
                )}
              <LI>
                {Invoicetotal} :
                <span className=" fw-bold">
                  ₹ {finalTotal ? finalTotal : invoiceValue?.order_total}
                </span>
              </LI>

              {/* <LI >{Prevdues} <span>{invoiceValue.currency_symbol}{invoiceValue.payment_due}</span></LI>
                    <LI >{TotalDues} <span classNamestyle='payable-dues'>{invoiceValue.currency_symbol}{invoiceValue.pending_amount}</span></LI>
                        <LI >{AmountCollected} <span>{invoiceValue.currency_symbol} {historyAmount}</span></LI>
                    <LI >{WalletMoney} <span>{invoiceValue.currency_symbol}{invoiceValue.wallet_money}</span></LI> */}
            </UL>
          </div>
        </div>
      </Col>
    </Fragment>
  );
};

export default InvoiceTotal;
